import { routes } from "@/data/routes";
import Cat from "@/svg/cat.svg";
import Link from "next/link";
import { Button } from "../base/button";

export function NotFound() {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gray-100">
      <div className="container flex flex-col items-center justify-center px-5 text-gray-700 md:flex-row">
        <div className="max-w-md">
          <div className="font-dark text-5xl font-bold">404</div>
          <p className="text-2xl leading-normal font-light md:text-3xl">
            Sorry we couldn&apos;t find this page.{" "}
          </p>
          <p className="mb-8">
            But dont worry, you can find plenty of other things on our homepage.
          </p>

          <Button asChild variant={"default"} size={"lg"}>
            <Link href={routes.home.path}>Back to Home</Link>
          </Button>
        </div>
        <div className="max-w-lg">
          <Cat />
        </div>
      </div>
    </div>
  );
}
